import { useInfiniteQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetInifiniteConversationAdmin = ({ id }: { id: string }) => {
  const token = localStorage.getItem("W2ST_ADMIN_TOKEN");

  return useInfiniteQuery({
    queryKey: ["getInifiniteConversationAdmin", id],
    queryFn: async ({ pageParam = 1 }) => {
      if (!token) throw new Error("Authorization token is missing");

      const response = await axiosInstance.get(
        `/admins/bookings/${id}/messages?page=${pageParam}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.data?.meta?.hasNextPage
        ? lastPage.data.meta.nextPage
        : undefined;
    },
    enabled: !!token,
  });
};
